<script setup lang="ts">
defineProps<{
  visible: boolean;
}>();

defineEmits<{
  continueWithoutPrint: [];
  retry: [];
}>();
</script>

<template>
  <div class="Printing__footer">
    <template v-if="visible">
      <button
        class="kiosk-button"
        data-testid="printing-retry"
        @click="$emit('retry')"
      >
        {{ $t('Printing.buttonPrintAgain') }}
      </button>
      <button
        class="kiosk-button-inline"
        data-testid="printing-continue"
        @click="$emit('continueWithoutPrint')"
      >
        {{ $t('Printing.buttonContinueWithoutPrint') }}
      </button>
    </template>
  </div>
</template>

<style scoped lang="scss">
.Printing__footer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1.5rem 3rem;
  padding: 0 1.35rem;
  margin-top: 1rem;
}
</style>
